<template>
  <v-form ref="form" @submit.prevent="submit" v-model="formValid">
    <v-row>
      <h3 class="black--text mb-4">Dados do Risco</h3>
    </v-row>
    <v-row>
      <v-row>
        <v-col cols="12" sm="4" class="pr-3">
          <BaseFormInput
            id-element="cepLocation"
            v-model="formLocation.endereco.cep"
            validate-on-blur
            v-facade="maskCEP"
            label-text="CEP"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="4" class="pr-3">
          <BaseFormInput
            id-element="cityLocation"
            v-model="formLocation.endereco.cidade"
            label-text="Cidade"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="4">
          <BaseFormSelect
            id-element="ufLocation"
            :items="brazilianStates"
            v-model="formLocation.endereco.uf"
            label-text="UF"
            item-text="nome"
            item-value="sigla"
            :return-object="true"
            disabled
          />
        </v-col>
      </v-row>
    </v-row>
    <v-row>
      <v-col cols="12" class="mb-8">
        <h3 class="black--text mb-4">Áreas Cadastradas</h3>
        <v-data-table
          :headers="headerItensTable"
          :items="formRisk2.areas"
          :server-items-length="formRisk2.areas.length"
          class="area-table base__datatable"
          :footer-props="{
            'items-per-page-options': [25, 50, 100, 250, 500]
          }"
          :hide-default-footer="true"
          :item-class="affectRow"
          item-key="item.area"
        >
          <template v-slot:[`item.area`]="{ item }">
            {{ "Área " + (formRisk2.areas.indexOf(item) + 1) }}
          </template>
          <template v-slot:[`item.nome`]="{ item }">
            {{ item.nome }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div
              :class="{
                'bg-green': getRowStatus(item) == 'Ok',
                'bg-yellow': getRowStatus(item) != 'Ok'
              }"
              class="status"
            >
              {{ getRowStatus(item) }}
            </div>
          </template>
          <template v-slot:[`item.visible`]="{ item }">
            <v-row class="mt-1 mb-1 vrow">
              <BaseButton
                ref="myDataTable"
                color="secondary"
                class="base-input-file__button mr-1 px-0"
                title="Visualizar"
                @click="viewRow(item)"
              >
                <img
                  style="width: 20px"
                  :src="require('@/assets/ic_eye.svg')"
                />
              </BaseButton>
              <BaseButton
                color="secondary"
                class="base-input-file__button mr-1 px-0"
                title="Editar"
                @click="editRow(item)"
              >
                <v-icon size="12"> fas fa-pencil-alt </v-icon>
              </BaseButton>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pb-6">
        <v-divider />
      </v-col>
    </v-row>
    <v-row v-if="selectedItem && selectedItem.plantedArea != null" class="pl-3">
      <!--Itens agrícolas-->
      <v-row class="mb-5 mt-5">
        <v-col cols="12" sm="4" md="4">
          <p class="form__label primary--text mb-2">
            Nome
          </p>
          <p class="body-2 primary--text mb-2">
            {{ selectedItem.nome }}
          </p>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p class="form__label primary--text mb-2">
            Área Plantada
          </p>
          <p class="body-2 primary--text mb-7">
            {{ Number(selectedItem.plantedArea).toFixed(2) }}
          </p>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p class="form__label primary--text mb-2">
            Técnica de Plantio
          </p>
          <p class="body-2 primary--text mb-7">
            {{ selectedItem.plantingTechniques.nome }}
          </p>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p class="form__label primary--text mb-2">
            Tipo de Solo
          </p>
          <p class="body-2 primary--text mb-7">
            {{ selectedItem.soilType.nome }}
          </p>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p class="form__label primary--text mb-2">
            Data de Plantio
          </p>
          <p class="body-2 primary--text mb-7">
            {{ selectedItem.plantingDate }}
          </p>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="4"
          v-if="selectedItem.claimCurrentHarvest != null"
        >
          <p class="form__label primary--text mb-2">
            Reivindicar Colheita Atual
          </p>
          <p class="body-2 primary--text mb-7">
            {{ selectedItem.claimCurrentHarvest ? "SIM" : "NÃO" }}
          </p>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p class="form__label primary--text mb-2">
            A lavoura já está plantada?
          </p>
          <p class="body-2 primary--text mb-7">
            {{ selectedItem.alreadyPlanted ? "SIM" : "NÃO" }}
          </p>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p class="form__label primary--text mb-2">
            Primeiro Ano de Plantio
          </p>
          <p class="body-2 primary--text mb-7">
            {{ selectedItem.yearsPlanting ? "SIM" : "NÃO" }}
          </p>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p class="form__label primary--text mb-2">
            Soja após Cana de Açúcar
          </p>
          <p class="body-2 primary--text mb-7">
            {{ selectedItem.soyAfterSuggarCane ? "SIM" : "NÃO" }}
          </p>
        </v-col>
      </v-row>
    </v-row>
    <!--Itens Cafezal-->
    <v-row v-if="selectedItem && selectedItem.areaPlantada != null">
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">
          Nome
        </p>
        <p class="body-2 primary--text mb-2">
          {{ selectedItem.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">
          Área Plantada
        </p>
        <p class="body-2 primary--text mb-7">
          {{ Number(selectedItem.areaPlantada).toFixed(2) }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">Espécie</p>
        <p class="body-2 primary--text mb-7">
          {{ selectedItem.especie.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">Variedade</p>
        <p class="body-2 primary--text mb-7">
          {{ selectedItem.variedade.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">Sistema de Cultivo</p>
        <p class="body-2 primary--text mb-7">
          {{ selectedItem.sistemaCultivo.nome }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">
          Idade da Planta (Anos)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ selectedItem.idade }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">
          Espaçamento entre Plantas (m)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ selectedItem.espacamentoPlantas }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">
          Espaçamento entre Linhas (m)
        </p>
        <p class="body-2 primary--text mb-7">
          {{ selectedItem.espacamentoLinhas }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">
          Plantas por Hectare
        </p>
        <p class="body-2 primary--text mb-7">
          {{ selectedItem.plantasPorHectare }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">
          Data da última recepa
        </p>
        <p class="body-2 primary--text mb-7">
          {{
            selectedItem.dataUltimaRecepa != null
              ? selectedItem.dataUltimaRecepa
              : "NÃO HOUVE"
          }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <p class="form__label primary--text mb-2">
          Danos no ciclo
        </p>
        <p class="body-2 primary--text mb-7">
          {{ selectedItem.danosNoCiclo ? "SIM" : "NÃO" }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-3 pb-6">
        <v-divider />
      </v-col>
    </v-row>
    <div v-if="enableArea && currentQuotation.cancelada_em == null">
      <v-row class="pb-0">
        <v-col class="pr-0 pr-sm-2">
          <h3 class="black--text mb-4">Adicionar Informações</h3>
        </v-col>
      </v-row>
      <v-row class="pb-0">
        <v-col class="pr-0 pr-sm-2">
          <BaseFormInput
            v-model="newAreaItem.logradouro"
            required
            :rules="[requiredInput, minLengthTextArea]"
            label-text="Logradouro"
            :disabled="this.readOnlyState"
            hide-no-data
            :return-object="false"
            :template-insured="true"
          />
        </v-col>
        <v-col class="pr-0">
          <BaseFormInput
            label-text="Número"
            v-model="newAreaItem.numero"
            :disabled="this.readOnlyState"
            type="number"
          />
        </v-col>
      </v-row>
      <v-row class="pb-0">
        <v-col class="pr-0 pr-sm-2">
          <BaseFormInput
            label-text="Complemento"
            v-model="newAreaItem.complemento"
            :disabled="this.readOnlyState"
            hide-no-data
            :return-object="false"
            :template-insured="true"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseFormInput
            label-text="Bairro"
            v-model="newAreaItem.bairro"
            :value="'zona rural'"
            required
            :rules="[requiredInput, minLengthTextArea]"
            :disabled="this.readOnlyState"
            hide-no-data
            :return-object="false"
            :template-insured="true"
          />
        </v-col>
        <v-col class="pr-0">
          <BaseFormInput
            label-text="CAR"
            v-model="newAreaItem.car"
            :disabled="this.readOnlyState"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pb-0">
          <BaseFormTextArea
            id-element="agreementJustify"
            placeholder=""
            v-model="newAreaItem.roteiro_acesso"
            :rules="[maxLengthTextArea]"
            label-text="Roteiro de Acesso"
            style="font-size: 10px;"
            :disabled="this.readOnlyState"
            :maxlength="maxLengthTextArea"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <QuotationFloatActionButton
          v-if="getUserIsGuest || !getIsEmployeeUser"
          :message="infoMessage"
        />
      </v-row>
      <v-row>
        <QuotationKMLFile
          ref="quotationKMLFile"
          :areaItem="this.newAreaItem"
          :expectedMinAreaSize="getExpectedMinAreaSize"
          :expectedMaxAreaSize="getExpectedMaxAreaSize"
          class="col col-lg-12"
          :alwaysOn="true"
        />
      </v-row>
      <v-row v-if="!readOnlyState">
        <v-col cols="2" class="mr-2">
          <BaseButton
            v-html="'Limpar'"
            class="secondary--text button-border"
            width="100%"
            outlined
            @click="clear()"
          />
        </v-col>
        <v-col cols="2" class="ml-2 mb-8">
          <BaseButton
            v-html="'Gravar Área'"
            class="white--text secondary"
            width="100%"
            @click="addRow()"
          />
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-if="currentQuotation.cancelada_em == null && showModalWrongAreaValue"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="showModalWrongAreaValue"
      width="700px"
    >
      <v-row class="white px-6 py-4">
        <h3 class="black--text mb-4 mt-4">Áreas Divergentes</h3>
      </v-row>
      <v-row class="white px-6">
        <v-col cols="12" class="pr-0">
          <p style="text-align:justify">
            Para prosseguir, a área desenhada ({{
              this.getMapsCalculatedArea()
            }}
            ha) deve ser do mesmo tamanho da área informada previamente ({{
              getPlantedArea
            }}
            ha), com variação de até 10%. Você confirma o novo tamanho de área
            ({{ this.getMapsCalculatedArea() }} ha)?
          </p>
        </v-col>
      </v-row>
      <v-row cols="12" class="white">
        <v-spacer />
        <v-col cols="3" class="pr-5 pb-8">
          <BaseButton
            class="white--text secondary"
            style="width:100%"
            @click="setPlantingAreaValue(true)"
          >
            Sim
          </BaseButton>
        </v-col>
        <v-col cols="3" class="pr-6">
          <BaseButton
            class="white--text secondary"
            style="width:100%"
            @click="setPlantingAreaValue(false)"
          >
            Não
          </BaseButton>
        </v-col>
      </v-row>
    </v-dialog>
    <v-dialog
      v-if="
        currentQuotation.cancelada_em == null && showModalWrongAreaPlantedValue
      "
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="showModalWrongAreaPlantedValue"
      width="700px"
    >
      <v-row class="white px-6 py-4">
        <h3 class="black--text mb-4">Incluir desenho da área</h3>
      </v-row>
      <v-row class="white px-6">
        <v-col cols="12" class="pr-0">
          <p style="text-align:justify">
            Para prosseguir, é necessário desenhar a área da propriedade ou
            importar o arquivo KML correspondente.
          </p>
        </v-col>
      </v-row>
      <v-row cols="12" class="white">
        <v-spacer />
        <v-col cols="3" class="mb-3 mr-6">
          <BaseButton
            class="white--text secondary"
            style="width:100%"
            @click="closedButton()"
          >
            Fechar
          </BaseButton>
        </v-col>
      </v-row>
    </v-dialog>
  </v-form>
</template>
<script>
import {
  requiredInput,
  maxLengthTextArea,
  minLengthTextArea,
  dateTermValid
} from "@/utils/rules.js";
import { maskCEP, maskDate } from "@/utils/masks.js";
import { brazilianStates } from "@/utils/utils.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import _ from "lodash";
import {
  asNumberString,
  formatExpirationDate,
  formatDDMMYYYYToIsoDate,
  formatDateToDDMMYYYY,
  formatIsoDateToDDMMYYYY
} from "@/utils/formats.js";
import QuotationKMLFile from "../components_agro/QuotationKMLFile.vue";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";

const headerItensTable = [
  { text: "Área", value: "area", fixed: true, sortable: false },
  { text: "Nome", value: "nome", fixed: true, sortable: false },
  { text: "Logradouro", value: "logradouro", sortable: false },
  { text: "Número", value: "numero", sortable: false },
  { text: "Complemento", value: "complemento", sortable: false },
  { text: "Bairro", value: "bairro", sortable: false },
  { text: "Status", value: "status", sortable: false },
  { text: "Ações", value: "visible", sortable: false }
];

const defaultItem = {
  id: null,
  nome: null,
  cep: null,
  cidade: null,
  uf: null,
  bairro: null,
  logradouro: null,
  numero: null,
  complemento: null,
  coordenadas: [],
  kmlFiles: [],
  car: null,
  roteiro_acesso: null,
  visible: true,
  status: null,
  plantedArea: null
};

export default {
  name: "QuotationRiskForm2",
  data: () => ({
    formValid: true,
    requiredInput,
    minLengthTextArea,
    maxLengthTextArea,
    maskCEP,
    brazilianStates,
    maskDate,
    dateTermValid,
    asNumberString,
    formatExpirationDate,
    formatDDMMYYYYToIsoDate,
    formatDateToDDMMYYYY,
    formatIsoDateToDDMMYYYY,
    headerItensTable,
    newAreaItem: null,
    editState: false,
    readOnlyState: false,
    nextId: 0,
    selectedRowToAffect: null,
    isAddingRow: false,
    areaPlantadaErrorMessages: [],
    enableArea: false,
    selectedItem: null,
    showModalWrongAreaValue: false,
    showModalWrongAreaPlantedValue: false,
    itemEdit: null
  }),
  created() {
    this.newAreaItem = _.cloneDeep(defaultItem);
  },
  components: {
    QuotationKMLFile,
    QuotationFloatActionButton
  },
  computed: {
    ...mapState(["loadingStatus"]),
    ...mapState("quotation", ["currentQuotation"]),
    ...mapState("me", ["userIsEmployee", "userIsGuest"]),
    validForm() {
      return (
        this.newAreaItem.logradouro != null && this.newAreaItem.bairro != null
      );
    },
    validArea() {
      return (
        this.getMapsCalculatedArea() >= this.getExpectedMinAreaSize &&
        this.getMapsCalculatedArea() <= this.getExpectedMaxAreaSize
      );
    },
    getExpectedMinAreaSize() {
      return this.getPlantedArea * 0.9; // Por requisito foi definido 10% de tolerancia na variação da area plantada total
    },
    getExpectedMaxAreaSize() {
      return this.getPlantedArea * 1.1; // Por requisito foi definido 10% de tolerancia na variação da area plantada total
    },
    getPlantedArea() {
      return this.newAreaItem.areaPlantada ?? this.newAreaItem.plantedArea;
    },
    getUserIsGuest() {
      return this.userIsGuest;
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessage() {
      return (
        " Clique no quadrado pontilhado para anexar o arquivo KML OU navegue pelo mapa para incluir os pontos referentes a área selecionada." +
        "Por fim, clique em Gravar Área e repita o procedimento para as demais áreas. Quando todas estiverem com o status “OK”, clique em Próximo para emitirmos sua proposta."
      );
    }
  },
  mixins: [LoadingRequest, CompanyMixin],
  methods: {
    ...mapActions(["hasLoading", "showAlertNotification"]),
    getMapsCalculatedArea() {
      let areaMaps = this.$refs.quotationKMLFile.getAreaSizeInHa();
      return areaMaps;
    },
    validAreaPlanted() {
      let area = parseFloat(this.getMapsCalculatedArea());
      if (area > 0) {
        return true;
      }
      return false;
    },
    getRowStatus(item) {
      return item.logradouro != null && item.bairro != null ? "Ok" : "Pendente";
    },
    showModal(visible) {
      this.showModalWrongAreaValue = visible;
    },
    showModalInvalid(visible) {
      this.showModalWrongAreaPlantedValue = visible;
    },
    setPlantingAreaValue(change) {
      if (!change) {
        this.showModal(false);
        return;
      }
      if (change) {
        if (this.formLocation.agricola?.items?.length > 0) {
          this.newAreaItem.plantedArea = this.getMapsCalculatedArea();
        } else {
          this.newAreaItem.areaPlantada = this.getMapsCalculatedArea();
        }
        this.addRow(true);
        this.showModal(false);
      }
    },
    closedButton() {
      this.showModalInvalid(false);
    },
    cancelQuotation() {
      this.$emit("cancel");
    },
    filteredItems() {
      if (this.formLocation.agricola?.items?.length > 0) {
        return _.cloneDeep(this.formLocation.agricola.items);
      }
      if (this.formLocation.cafezal?.items?.length > 0) {
        return _.cloneDeep(this.formLocation.cafezal.items);
      }
    },
    focusDataTable() {
      setTimeout(() => {
        this.$refs.myDataTable.$el.focus();
      }, 200);
    },
    focusForm() {
      setTimeout(() => {
        window.scrollBy(0, 550);
      }, 200);
    },
    addNewArea(item) {
      this.newAreaItem = item;
      this.selectedItem = item;
      this.enableArea = true;
      this.focusForm();
    },
    addRow(confirm) {
      if (!this.validForm) {
        this.showAlertNotification({
          message: "Preencha todos os campos corretamente antes de prosseguir.",
          type: "error"
        });
        return;
      }

      if (this.validAreaPlanted() == false) {
        this.showModalInvalid(true);
        return;
      }

      if (!this.validArea && this.validAreaPlanted() == true && !confirm) {
        this.showModal(true);
        return;
      }

      let index = this.formRisk2.areas.findIndex(
        x => x.id == this.newAreaItem.id
      );

      this.newAreaItem.status = "Ok";
      this.newAreaItem.coordenadas = this.$refs.quotationKMLFile.getCoordinates();
      this.newAreaItem.cep = this.formLocation.endereco.cep;
      this.newAreaItem.uf = this.formLocation.endereco.uf;
      this.newAreaItem.cidade = this.formLocation.endereco.cidade;
      this.formRisk2.areas[index] = _.cloneDeep(this.newAreaItem);
      // força atribuição no array p/ o vue detectar a alteração e deixar reativo
      this.formRisk2.areas = this.formRisk2.areas.slice();
      this.limparInput();
      this.focusDataTable();
      this.showAlertNotification({
        message: "Área salva com sucesso.",
        type: "success"
      });
      this.enableArea = false;
      this.selectedItem = false;
      return;
    },
    aboveZero(value) {
      return value > 0 || "O valor deve ser maior do que 0.";
    },
    limparInput() {
      this.newAreaItem = _.cloneDeep(defaultItem);
      this.areaPlantadaErrorMessages = [];
    },
    viewRow(item) {
      this.selectedItem = item;
      this.newAreaItem = _.cloneDeep(item);
      this.readOnlyState = true;
      this.enableArea = true;
      this.isAddingRow = false;
      this.selectedRowToAffect = this.formRisk2.areas.indexOf(item);
      this.focusForm();
    },
    editRow(item) {
      this.newAreaItem = _.cloneDeep(item);
      this.newAreaItem.bairro = this.newAreaItem.bairro
        ? this.newAreaItem.bairro
        : "Zona Rural";
      this.newAreaItem.numero = this.newAreaItem.numero
        ? this.newAreaItem.numero
        : "0";
      this.selectedItem = item;
      this.enableArea = true;
      this.readOnlyState = false;
      this.editState = true;
      this.isAddingRow = false;
      this.selectedRowToAffect = this.formRisk2.areas.indexOf(item);
      this.focusForm();
    },
    clear() {
      this.newAreaItem.coordenadas = [];
      this.newAreaItem.kmlFiles = [];
      this.newAreaItem.logradouro = null;
      this.newAreaItem.numero = null;
      this.newAreaItem.bairro = null;
      this.newAreaItem.complemento = null;
      this.newAreaItem.car = null;
      this.newAreaItem.roteiro_acesso = null;
    },
    affectRow(item) {
      let selectedRow = this.formRisk2.areas.indexOf(item);
      let itemClass = "";

      if (this.isAddingRow) {
        itemClass = "table-row";
      }

      if (this.selectedRowToAffect === selectedRow) {
        itemClass += "selected-row";
      }

      return itemClass;
    }
  },
  props: {
    formRisk2: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    formInsured: {
      type: Object
    },
    formLocation: {
      type: Object
    }
  }
};
</script>
<style>
.status {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-green {
  background-color: #16eba3;
}

.bg-yellow {
  background-color: #faf677;
}
</style>
